import { render, staticRenderFns } from "./list-item-especie.vue?vue&type=template&id=2e0a1c44"
import script from "./list-item-especie.vue?vue&type=script&lang=js"
export * from "./list-item-especie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports